import { render, staticRenderFns } from "./courseTaskDetails.vue?vue&type=template&id=80e60bcc"
import script from "./courseTaskDetails.vue?vue&type=script&lang=js"
export * from "./courseTaskDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports